export default __webpack_public_path__ + "static/media/fishing.37157a25.jpg";